<template>
  <div>
    default12
    <sj-card style="padding: 10px;">
      <SjBaseTable1
        :columns="columnsSimple2"
        :data="dataSimple2"
        :tableProps="tableProps2"
        @sort-change="handleSortChange"
        @filter-change="handleFilterChange"
      >
      </SjBaseTable1>
    </sj-card>
    <div style="height: 5px;"></div>

    medium
    <sj-card style="padding: 10px;">
      <SjBaseTable1
        :columns="columnsSimple2"
        :data="dataSimple2"
        :tableProps="tableProps"
        size="medium"
      >
      </SjBaseTable1>
    </sj-card>
    <div style="height: 5px;"></div>
    small
    <sj-card style="padding: 10px;">
      <SjBaseTable1
        :columns="columnsSimple2"
        :data="dataSimple2"
        :tableProps="tableProps"
        size="small"
      >
      </SjBaseTable1>
    </sj-card>
    <div style="height: 5px;"></div>
    <sj-card style="padding: 10px;">
      <SjBaseTable1
        :columns="columnsSimple2"
        :data="[]"
        :tableProps="tableProps"
      >
      </SjBaseTable1>
    </sj-card>
    <div style="height: 5px;"></div>
  </div>
</template>

<script>
import CustomEle from "./CustomEle";
export default {
  data() {
    return {
      tableProps: {
        "highlight-current-row": true,
        "highlight-hover": true,
        defaultSelection: 0,
        maxHeight: 300,
        stripe: false,
        cellClassName({ rowIndex, columnIndex }) {
          return `row${rowIndex}$column${columnIndex}`;
        },
        headerStyles({ columnIndex }) {
          if (columnIndex === 0)
            return {
              backgroundColor: "lightblue"
            };
          return {};
        },
        cellStyles({ columnIndex }) {
          if (columnIndex === 0)
            return {
              backgroundColor: "lightblue"
            };
          return {};
        }
      },
      tableProps2: {
        maxHeight: 300,
        "highlight-current-row": true,
        "highlight-hover": false,
        stripe: false,
        border: true
      },
      columnsSimple2: [
        {
          prop: "name",
          label: "名称",
          fixed: true,
          width: 80
        },
        {
          prop: "row1",
          label: "列1",
          width: 300,
          filterable: true,
          sortable: true,
          filterPlaceholder: "大于",
          renderFilter(h, { onFilterChange, filterValue }) {
            return (
              <SjInput border value={filterValue} onInput={onFilterChange} />
            );
          },
          renderHeader() {
            return <div>自定义表头</div>;
          }
        },
        {
          prop: "row2",
          label: "列2",
          width: 300,
          filterable: "category",
          filterOptions: [
            { label: "清空", value: null },
            ...["天使轮", "A轮", "B轮", "C轮", "C+轮"].map(v => ({
              label: v,
              value: v
            }))
          ],
          customRender: (h, { row, column }) => (
            <CustomEle>custom render{row[column.prop]}</CustomEle>
          )
        },
        {
          prop: "row3",
          label: "列3",
          align: "center",
          width: 300,
          sortable: true,
          filterable: true,
          formatter(v) {
            return (v / 10).toFixed(1);
          }
        }
      ],
      dataSimple2: Array.from({ length: 10 }).map((v, i) => ({
        name: i,
        row1: Math.floor(Math.random() * 1000),
        row2: ["天使轮", "A轮", "B轮", "C轮", "C+轮"][
          Math.floor(Math.random() * 5)
        ],
        row3: Math.floor(Math.random() * 1000)
      }))
    };
  },
  methods: {
    handleCellClick(row, column) {
      if (column.property === "row1") {
        alert(JSON.stringify(row));
      }
    },
    handleFilterChange(filters) {
      console.log(filters);
    },

    handleSortChange(sort) {
      console.log(sort);
    },
    customFilter(data, filterConfig) {
      return data.filter(item =>
        Object.keys(filterConfig).every(
          key => !filterConfig[key] || item[key] > filterConfig[key]
        )
      );
    }
  }
};
</script>

<style scoped lang="less"></style>
